import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { useDialogState } from '~/modules/common/hooks';
import { SelectAllButton } from '../../common';
import TaskAssignmentSearchBox from './TaskAssignmentSearchBox';
import TaskAssignmentBulkActionDialog from './TaskAssignmentBulkActionDialog';

const useStyles = makeStyles(theme => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1.5)
  }
}));

const TaskAssignmentDialogHeader = ({
  loading,
  assignedTasksCount,
  totalMatchingTasksCount,
  searchCriteria,
  setSearchCriteria,
  resource,
  projectId,
  permittedActionUris,
  textSearch,
  resetTaskAssignments,
  onTaskAssignmentUpdateSuccess
}) => {
  const classes = useStyles();

  const {
    open: isTaskAssignmentBulkActionDialogOpen,
    openDialog: openTaskAssignmentBulkActionDialog,
    closeDialog: closeTaskAssignmentBulkActionDialog
  } = useDialogState(false);

  const canEditTask = permittedActionUris.includes(
    'urn:replicon:project-action:edit-tasks'
  );
  const shouldSearchBoxFocused =
    loading || !canEditTask || !totalMatchingTasksCount;

  return (
    <div className={classes.header}>
      <SelectAllButton
        loading={loading}
        assignedTasksCount={assignedTasksCount}
        totalMatchingTasksCount={totalMatchingTasksCount}
        hasPermission={canEditTask}
        onClick={openTaskAssignmentBulkActionDialog}
      />
      {isTaskAssignmentBulkActionDialogOpen && (
        <TaskAssignmentBulkActionDialog
          open={isTaskAssignmentBulkActionDialogOpen}
          onClose={closeTaskAssignmentBulkActionDialog}
          assignedTasksCount={assignedTasksCount}
          impactedTaskCount={totalMatchingTasksCount}
          resource={resource}
          projectId={projectId}
          textSearch={textSearch}
          resetTaskAssignments={resetTaskAssignments}
          onTaskAssignmentUpdateSuccess={onTaskAssignmentUpdateSuccess}
        />
      )}
      <TaskAssignmentSearchBox
        searchCriteria={searchCriteria}
        setSearchCriteria={setSearchCriteria}
        autoFocus={shouldSearchBoxFocused}
      />
    </div>
  );
};

TaskAssignmentDialogHeader.propTypes = {
  loading: PropTypes.bool,
  assignedTasksCount: PropTypes.number,
  totalMatchingTasksCount: PropTypes.number,
  searchCriteria: PropTypes.object.isRequired,
  setSearchCriteria: PropTypes.func.isRequired,
  resource: PropTypes.object.isRequired,
  projectId: PropTypes.string.isRequired,
  permittedActionUris: PropTypes.array.isRequired,
  resetTaskAssignments: PropTypes.func.isRequired,
  onTaskAssignmentUpdateSuccess: PropTypes.func.isRequired,
  textSearch: PropTypes.string
};

export default TaskAssignmentDialogHeader;
